import {ExclusivePair, ExportDefaultToggle} from './exportDefaults';

export type QboExportDefaultField =
	| 'qboExportDefaultInvoiceRef'
	| 'qboExportDefaultDescription'
	| 'qboExportDefaultProjectNameInDesc'
	| 'qboExportDefaultTerms'
	| 'qboExportDefaultTax';

export type QboExportDefaults = Record<QboExportDefaultField, boolean>;

/** As stored on Company: null/undefined means no Admin has saved defaults yet. */
export type StoredQboExportDefaults = Record<QboExportDefaultField, boolean | null | undefined>;

// Order matches the Export to QuickBooks window.
export const QBO_EXPORT_DEFAULT_TOGGLES: ReadonlyArray<ExportDefaultToggle<QboExportDefaultField>> = [
	{
		field: 'qboExportDefaultInvoiceRef',
		labelId: 'invoicing.quickbooks.control_reference',
		helperId: 'integrations.quickbooks.export_defaults.invoice_ref_helper',
	},
	{
		field: 'qboExportDefaultDescription',
		labelId: 'invoicing.quickbooks.use_product_service_descriptions',
		helperId: 'integrations.quickbooks.export_defaults.description_helper',
	},
	{
		field: 'qboExportDefaultProjectNameInDesc',
		labelId: 'invoicing.quickbooks.include_project_name_in_description_when_exporting',
		helperId: 'integrations.quickbooks.export_defaults.project_name_helper',
	},
	{
		field: 'qboExportDefaultTerms',
		labelId: 'invoicing.quickbooks.use_terms',
		helperId: 'integrations.quickbooks.export_defaults.terms_helper',
	},
	{
		field: 'qboExportDefaultTax',
		labelId: 'invoicing.quickbooks.use_default_tax',
		helperId: 'integrations.quickbooks.export_defaults.tax_helper',
	},
];

// If QuickBooks supplies the line description, Forecast cannot prefix the project name to it.
// Order matters: the export window keeps the first field of a stored pair (T4-150 D3).
export const QBO_EXCLUSIVE_PAIRS: ReadonlyArray<ExclusivePair<QboExportDefaultField>> = [
	['qboExportDefaultDescription', 'qboExportDefaultProjectNameInDesc'],
];

// An option no Admin has saved - or a company not read at all - is off.
export const toQboExportDefaults = (stored: Partial<StoredQboExportDefaults> | null | undefined): QboExportDefaults => ({
	qboExportDefaultInvoiceRef: stored?.qboExportDefaultInvoiceRef === true,
	qboExportDefaultDescription: stored?.qboExportDefaultDescription === true,
	qboExportDefaultProjectNameInDesc: stored?.qboExportDefaultProjectNameInDesc === true,
	qboExportDefaultTerms: stored?.qboExportDefaultTerms === true,
	qboExportDefaultTax: stored?.qboExportDefaultTax === true,
});

/** The card shows only behind the feature flag, and only while QuickBooks is connected. */
export const shouldShowQboExportDefaults = (hasFlag: boolean, quickbooksEnabled: boolean): boolean =>
	hasFlag && quickbooksEnabled;
